<template>
  <div class="" v-if="subscription">
    <div class="md:grid md:grid-cols-3 md:gap-6">
      <div class="md:col-span-1">
        <div class="px-4 sm:px-0">
          <h3 class="text-lg font-medium leading-6 text-gray-900">
            {{ $t('subscription_title') }}
          </h3>
          <p class="mt-1 text-sm leading-5 text-gray-600">
            {{ $t('subscription_description') }}
          </p>
        </div>
      </div>
      <div class="mt-5 md:mt-0 md:col-span-2">
        <div
          class="px-4 py-5 bg-white sm:p-6 shadow overflow-hidden sm:rounded-md grid grid-cols-2 gap-6"
        >
          <div class="col-span-6 text-gray-800">
            <p class="mb-3">
              Simple590 est proposé gratuitement et sans garantie.
            </p>
          </div>
          <div>
            <router-link
              :to="{ name: 'account-delete', params: { aid: uid } }"
              class="text-red-600 hover:text-red-500 underline"
            >
              {{ $t('subscription_account_delete') }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import amount from '@/filters/amount';
import { mapGetters } from 'vuex';

export default {
  name: 'SubscriptionPanel',
  filters: { amount },
  props: { subscription: Object },
  computed: {
    ...mapGetters('auth', ['uid'])
  }
};
</script>
